'use client';
import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { ActionPortalMenuBar } from './ActionPortalMenuBar';
import { useTranslation } from 'react-i18next';
import i18n from '../../app/localization/i18n';

export const PageTitleContext = React.createContext(null);

export const useSetPageTitle = (title: string) => {
  const changePageTitle = React.useContext(PageTitleContext);

  useEffect(() => {
    changePageTitle(title);
  }, []);
};

const MainContentContainer = styled.main`
  margin-top: 100px;
  height: calc(100vh - 100px); //view height minus header
`;

interface AdminNavigationProps {
  children: React.ReactNode;
}

export const ActionPortalNavigation: React.FC<AdminNavigationProps> = ({ children }) => {
  const { t } = useTranslation('headerFooter', { i18n });
  const [title, setTitle] = React.useState(t('action_portal'));

  // re-run when language changes
  useEffect(() => {
    setTitle(t('action_portal'));
  }, [t, i18n.language]);

  const changePageTitle = (title: string) => {
    setTitle(title);
  };

  return (
    <>
      <ActionPortalMenuBar title={title} />
      <PageTitleContext.Provider value={changePageTitle}>
        <MainContentContainer>{children}</MainContentContainer>
      </PageTitleContext.Provider>
    </>
  );
};
